import { RouteConfig } from "vue-router";
// import { REmployeesBrowse } from "@/modules/Employees/Browse/REmployeesBrowse";
import { REmployeesBrowseOld } from "@/modules/Employees/Browse/REmployeesBrowseOld";
import { REmployeesTemplate } from "@/modules/Employees/Template/REmployeesTemplate";

export const RCompanyEmployees: RouteConfig = {
  path: "employees",
  component: () =>
    import(
      /* webpackChunkName: "companies-template-company-employees" */
      "./VCompanyEmployees.vue"
    ),
  meta: {
    label: "employees",
    title: "Companies",
  },
  children: [REmployeesBrowseOld, REmployeesTemplate],
};
